import { create } from 'zustand';
import type { PendingEdit } from '@/lib/ai-composer/applier-registry';

export type EditActionStatus = 'idle' | 'requesting' | 'streaming' | 'review' | 'error';

interface EntityEditState {
  status: EditActionStatus;
  pending?: PendingEdit;
  error?: string;
}

interface EditActionStoreState {
  byEntity: Record<string, EntityEditState>;
  toRequesting: (entityId: string, pending: PendingEdit) => void;
  start: (entityId: string, pending: PendingEdit) => void;
  toReview: (entityId: string) => void;
  fail: (entityId: string, error: string) => void;
  reset: (entityId: string) => void;
}

export const useEditActionStore = create<EditActionStoreState>((set) => ({
  byEntity: {},
  toRequesting: (entityId, pending) =>
    set((s) => ({ byEntity: { ...s.byEntity, [entityId]: { status: 'requesting', pending } } })),
  start: (entityId, pending) =>
    set((s) => ({
      byEntity: {
        ...s.byEntity,
        [entityId]: { status: 'streaming', pending },
      },
    })),
  toReview: (entityId) =>
    set((s) => {
      const current = s.byEntity[entityId];
      if (!current) return s;
      return {
        byEntity: {
          ...s.byEntity,
          [entityId]: { ...current, status: 'review' },
        },
      };
    }),
  fail: (entityId, error) =>
    set((s) => ({
      byEntity: {
        ...s.byEntity,
        [entityId]: { status: 'error', error },
      },
    })),
  reset: (entityId) =>
    set((s) => {
      const next = { ...s.byEntity };
      delete next[entityId];
      return { byEntity: next };
    }),
}));
